import { alpha, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';

import Loading from './Loading';
import SpinnerLoader from './SpinnerLoader';

const CenteredSpinnerOverlay = styled('div')(({ theme }) => {
  const overlayGradient = theme.palette.mode === 'light'
    ? `radial-gradient(circle at center, ${alpha(theme.palette.common.white, 0.78)} 0%, ${alpha(theme.palette.background.paper, 0.58)} 22%, ${alpha(theme.palette.background.default, 0.24)} 48%, transparent 72%)`
    : `radial-gradient(circle at center, ${alpha(theme.palette.common.black, 0.76)} 0%, ${alpha(theme.palette.background.paper, 0.52)} 24%, ${alpha(theme.palette.background.default, 0.22)} 50%, transparent 74%)`;

  return {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: theme.zIndex.tooltip + 2,
    pointerEvents: 'none',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage: overlayGradient,
    },
  };
});

const CenteredSpinnerContent = styled('div')({
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
  pointerEvents: 'none',
});

const ModalLoadingFallback = ({
  label = 'Inhalt wird geladen',
  reducedMotion = false,
}) => {
  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <>
      <Loading label={label} />
      <CenteredSpinnerOverlay>
        <CenteredSpinnerContent>
          <SpinnerLoader
            label={label}
            reducedMotion={reducedMotion}
          />
        </CenteredSpinnerContent>
      </CenteredSpinnerOverlay>
    </>,
    document.body,
  );
};

ModalLoadingFallback.propTypes = {
  label: PropTypes.string,
  reducedMotion: PropTypes.bool,
};

export default ModalLoadingFallback;